/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	slug: z.string(),
	meta: z.record(z.string(), z.unknown()).nullable(),
	workosId: z.string().nullable(),
	updatedAt: z.iso.datetime(),
	careerSiteEnabled: z.boolean().default(false),
	candidateProfileEnabled: z.boolean().default(true),
	candidateProfileCvCollectionEnabled: z.boolean().default(true),
	membershipStatus: z.string().nullable(),
	membershipId: z.string().nullable(),
	isDemo: z.boolean().default(false),
	hasParent: z.boolean().nullable(),
	hasChildren: z.boolean().nullable(),
	isSalesDriven: z.boolean().nullable(),
})

export type OrganisationDataSchema = z.infer<typeof organisationDataSchema>
